import React from 'react';

const FAQ = () => {
    return (
        <div>
            <h2>This is from Frequently asked question</h2>
        </div>
    );
};

export default FAQ;